import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { customerApi, money, fmtDate, statusPill, statusLabel } from '../../lib/api';
import PullToRefresh from '../../components/PullToRefresh';

export default function CustomerInvoices() {
  const [invoices, setInvoices] = useState([]);
  const [q, setQ] = useState('');
  const [status, setStatus] = useState('');

  const load = () => {
    const params = {};
    if (q) params.q = q;
    if (status) params.status = status;
    return customerApi.get('/customer/invoices', { params }).then((r) => setInvoices(r.data));
  };
  useEffect(() => { load(); }, [q, status]);

  return (
    <PullToRefresh onRefresh={load}>
    <div className="fade-in space-y-4" data-testid="customer-invoices-page">
      <h1 className="text-3xl font-semibold">My Invoices</h1>

      <div className="card p-3 flex flex-wrap gap-2">
        <div className="flex items-center gap-2 flex-1 min-w-[180px]">
          <Search size={16} className="text-[#6b7280]" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search invoice #" className="flex-1 border-none outline-none text-sm bg-transparent" data-testid="cust-invoice-search" />
        </div>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="text-sm border border-[#e7e7e7] rounded-lg px-3 py-2" data-testid="cust-invoice-status-filter">
          <option value="">All</option><option value="unpaid">Unpaid</option><option value="partial">Partial</option><option value="paid">Paid</option>
        </select>
      </div>

      {invoices.length === 0 ? (
        <div className="card p-10 text-center text-sm text-[#6b7280]">No invoices found.</div>
      ) : (
        <div className="space-y-2">
          {invoices.map((inv) => {
            const balance = inv.total - inv.paid_amount;
            return (
              <Link to={`/portal/invoices/${inv.invoice_id}`} key={inv.invoice_id} className="card p-4 flex items-center justify-between hover:border-[#d92027] transition-colors" data-testid={`cust-inv-${inv.invoice_id}`}>
                <div>
                  <div className="flex items-center gap-2"><span className="mono font-semibold">{inv.invoice_number}</span><span className={statusPill(inv.status)}>{statusLabel(inv.status)}</span></div>
                  <div className="text-xs text-[#6b7280] mt-0.5">Issued {fmtDate(inv.issue_date)} · Due {fmtDate(inv.due_date)}</div>
                </div>
                <div className="text-right">
                  <div className="mono font-semibold">{money(inv.total)}</div>
                  {balance > 0 ? <div className="text-xs mono text-[#d92027]">{money(balance)} due</div> : <div className="text-xs text-green-700 font-semibold">Paid ✓</div>}
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
    </PullToRefresh>
  );
}
